<template>
  <div v-if="count > 0" class="flex items-center min-w-0" data-test="investor-avatars">
    <div v-if="circles.length" class="flex flex-shrink-0 mr-2">
      <span
        v-for="(circle, index) in circles"
        :key="index"
        class="flex items-center justify-center w-7 h-7 rounded-full border-2 border-white text-white text-11 font-bold"
        :class="[circle.color, { '-ml-1': index > 0 }]"
      >
        {{ circle.text }}
      </span>
    </div>
    <span v-if="showCount" class="text-11 text-white truncate">
      {{ $t('projects.greenhouse.investors', { investorCount: count }, count) }}
    </span>
  </div>
</template>

<script>
import { computed } from 'vue'

// Brand palette, full class names so they survive the tailwind purge
// Alternating green / orange, so neighbouring circles never share a colour family
const COLORS = [
  'bg-green-forest-1',
  'bg-orange-earth-1',
  'bg-green-forest-2',
  'bg-orange-coral-1'
]

export default {
  props: {
    // Up to 3 investor initials, e.g. ['JM', 'AK', 'RL']
    initials: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    },
    // Off when the investor count is already shown next to it
    showCount: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    // Stable start colour from the initials (simple hash), then consecutive palette colours so the circles always differ
    const circles = computed(() => {
      const initials = (props.initials || []).slice(0, 3)
      let start = 0
      for (const char of initials.join('')) {
        start = (start * 31 + char.charCodeAt(0)) % COLORS.length
      }
      return initials.map((text, i) => ({ text, color: COLORS[(start + i) % COLORS.length] }))
    })

    return { circles }
  }
}
</script>
